import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Constant from '../../Constant'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
class AdminPickUpLists extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
  }

  componentDidMount() {
    this.dashbord()
  }
  dashbord = async () => {
    var that = this
    this.setState({ isloading: true })
    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ isloading: false })
          that.setState({
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'vendorName',
        label: `Vendor Name`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'pickup_vendor_charge',
        label: 'Pick Up Vendor Charge',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'pickup_address_en',
        label: 'Pick Up Address: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'pickup_address_ar',
        label: 'Pick Up Address: Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'pickup_lat',
        label: `Latitude`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'pickup_long',
        label: `Longitude`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'pickup_desc',
        label: 'Description',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'pickup_other_detail',
        label: `Other Details`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/pickup/add/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>PickUp List</h4>
                    </div>
                  </div>
                  <Link
                    to="/pickup/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i>
                    PickUp Add
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">PickUp List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`PickUp List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AdminPickUpLists
